<template>
<v-card>
  <v-card-title>
    Edit Item - {{ propItem.serialNumber }}

  <div class="flex-grow-1"></div>
    <v-btn icon @click="closeEdit">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text>
    <v-row>
      <v-col>
        <!-- <v-text-field v-model="propItem.Customer.name" label="Customer" append-icon="mdi-magnify" @click:append="searchForCustomer" @keyup.enter="searchForCustomer"></v-text-field> -->
        <v-text-field v-model="customerNameSearch" label="Customer" append-icon="mdi-magnify" @click:append="searchForCustomer" @keyup.enter="searchForCustomer" clearable @click:clear="removeCustomer"></v-text-field>

        <v-data-table
        v-if="(customers && customers.length > 0)"
        :headers="customersHeaders"
        :items="customers"
        class="elevation-1"
        @click:row="rowClicked">
        </v-data-table>

        <v-select :items="locations" v-model="propItem.LocationId" label="Location" item-text="name" item-value="id" @change="onLocationUpdated"></v-select>
        <v-select :items="iothubs" :disabled="propItem.LocationId !== locations.find(location => location.name === 'Customer').id" v-model="propItem.iothub" label="IoTHUB" item-text="friendlyName" item-value="iothub"></v-select>

        <v-textarea v-model="patchNotes" label="Notes"></v-textarea>

        <v-select
          v-model="selectedTags"
          :items="logTags"
          item-text="name"
          item-value="name"
          multiple>
          <template v-slot:append-item>
            <v-divider class="mb-2"></v-divider>

            <v-list-item>
              <v-text-field label="Add new tag" append-icon="mdi-plus" @click:append="addNewTag" @keyup.enter="addNewTag" v-model="newTag"></v-text-field>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-row v-if="errorMessage">
      <v-col>
        {{ errorMessage }}
      </v-col>
    </v-row>

    <v-row>
      <div class="flex-grow-1"></div>

      <v-col class="text-right">
        <v-btn class="mr-3" v-if="customerNameSearch !== originalCustomerName" @click="newCustomer">
          New Customer
        </v-btn>
        <v-btn class="mr-3" color="success" @click="saveChanges" :loading="loading" :disabled="customerNameSearch !== originalCustomerName">
          Save
        </v-btn>
        <v-btn @click="closeEdit" :disabled="loading">
          Cancel
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>

</template>

<script>
import axios from 'axios'

export default {
  name: 'EditItem',

  props: ['propItem'],

  mounted () {
    this.originalCustomerName = (this.propItem.Customer ? this.propItem.Customer.name : '')
    this.customerNameSearch = (this.propItem.Customer ? this.propItem.Customer.name : '')
    // In case we have customers from previous search,
    // we remove them here so it won't show at once EditItem is rendered
    this.$store.commit('setCustomers', [])
  },

  data: () => ({
    originalCustomerName: '',
    customerNameSearch: '',
    patchNotes: '',
    selectedTags: [],
    newTag: '',
    loading: false,
    errorMessage: '',
    customersHeaders: [
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' }
    ]
  }),

  methods: {
    closeEdit () {
      console.log('closeEdit triggered')
      this.$emit('closeEdit')
      this.$store.commit('setCustomers', [])
      this.errorMessage = ''
      this.loading = false
    },

    addNewTag () {
      this.selectedTags.push(this.newTag)
      this.logTags.push(this.newTag)
      this.newTag = ''
    },

    searchForCustomer () {
      console.log('searchForCustomer triggered')

      this.$store.dispatch('getCustomersByFilter', this.customerNameSearch)
    },

    rowClicked (customer) {
      console.log('rowClicked customer.id:', customer.id)

      this.propItem.CustomerId = customer.id
      // this.propItem.Customer.name = customer.name
      this.customerNameSearch = customer.name
      this.originalCustomerName = customer.name
      this.$store.commit('setCustomers', [])
    },

    async saveChanges () {
      console.log('saveChanges triggered')

      this.loading = true

      const payload = {
        customerId: this.propItem.CustomerId,
        locationId: this.propItem.LocationId,
        iothub: this.propItem.iothub,
        notes: this.patchNotes,
        tags: this.selectedTags
      }

      try {
        await axios.patch(process.env.VUE_APP_API_URL + '/item/' + this.propItem.id, payload)
        this.closeEdit()
      } catch (err) {
        console.error('Error trying to saveChanges axios.patch()', err)
        this.errorMessage = err
        this.loading = false
      }
    },

    newCustomer () {
      this.$router.push({ path: '/customers', query: { newCustomer: this.customerNameSearch } })
    },

    removeCustomer () {
      console.log('removeCustomer() triggered')
      this.originalCustomerName = null
      this.propItem.CustomerId = ''
      this.customerNameSearch = null
    },

    onLocationUpdated () {
      console.log('onLocationUpdated() triggered')

      const isCustomerLocation = this.propItem.LocationId === this.locations.find(location => location.name === 'Customer').id

      if (isCustomerLocation) {
        console.log('IS customer Location')
      } else {
        console.log('Is NOT customer Location')
        this.propItem.iothub = null
        this.removeCustomer()
      }
    }
  },

  computed: {
    locations () {
      return this.$store.state.locations
    },

    iothubs () {
      const iothubs = this.$store.state.iothubs
      iothubs.push({ friendlyName: 'None', iothub: null })

      return iothubs
    },

    customers () {
      return this.$store.state.customers
    },

    logTags () {
      return this.$store.state.logTags
    }
  }
}
</script>
